var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (Boolean(_vm.product))?_c('div',{staticClass:"product"},[_c('PProductInfo',_vm._b({},'PProductInfo',_vm.product,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }